import NiceModal from "@ebay/nice-modal-react";
import P from "components/P";
import Container from "layouts/container/Container";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import { AuthContext } from "providers/AuthProvider";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import DummyCard from "routes/front/main/DummyCard";
import { CartReducer } from "shared/redux/reducers/shopping/CartReducer";

function ProductList() {
    const location = useLocation();
    const dispatch = useDispatch();

    const { userName } = useContext(AuthContext);
    const { isMobile } = useContext(BrowserDetectContext);
    const [products, setProducts] = useState();
    const navigate = useNavigate();
    const { id } = useParams();


    useEffect(() => {
        if (location) {
            if(location.state){
            setProducts(location.state.products);
            }else{
                
            setProducts([]);
            }
            

        }
    }, [location])

    const ProductCard = (props) => {
        const { data } = props;
        const onClickProduct = () => {
            
            navigate(`/ws/${id}/homepage/detail/${data.id}`, { state: { data: data } })
        }

        return (
            <div
                style={{
                    display: "flex",
                    flex: isMobile ? "1 1 43%" : "1 1 23%",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "white",
                    padding: "20px 0",
                }}
                
            >
                <div
                    style={{
                        borderRadius: "10px",
                        width: "93%",
                        padding: "10px",
                        boxShadow: "3px 2px 14.100000381469727px 0 rgba(254, 83, 31, 0.5)",
                    }}
                    onClick={onClickProduct}
                >
                    <VerticalFlex gap={10}>
                        <FlexChild>
                            <div
                                style={{
                                    padding: "10px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}

                            >
                                <img src={data.productImg} width={"100%"} />
                            </div>
                        </FlexChild>
                        <FlexChild>
                            <Center>
                                <P ellipsis size={isMobile ? "1.7vw" : 15}>
                                    {data.productName}
                                </P>
                                <P size={20}>
                                    {data.price ? data.price.toLocaleString() : '가격 없음'}원
                                </P>
                            </Center>
                        </FlexChild>
                        {/* <FlexChild>
                            <HorizontalFlex gap={20}>
                                <FlexChild justifyContent={"flex-end"}>
                                    <P
                                        size={isMobile ? "1vw" : 10}
                                        borderRadius={"30px"}
                                        color={"white"}
                                        backgroundColor={"#EC4715"}
                                        padding={"7px 15px"}
                                        cursor={"pointer"}
                                        // onClick={orderClick}
                                    >
                                        구매하기
                                    </P>
                                </FlexChild>
                                <FlexChild justifyContent={"flex-start"}>
                                    <P
                                        size={isMobile ? "1vw" : 10}
                                        borderRadius={"30px"}
                                        border={"1px solid #EC4715"}
                                        color={"#EC4715"}
                                        padding={"5px 15px"}
                                        // onClick={addCartClick}
                                        cursor={"pointer"}
                                    >
                                        장바구니
                                    </P>
                                </FlexChild>
                            </HorizontalFlex>
                        </FlexChild> */}
                    </VerticalFlex>
                </div>
            </div>
        );
    };
    const totalProducts = products && products.length;
    const dummyElementsCount = 4 - (totalProducts % 4);
    const mobileDummyElementsCount = 2 - (totalProducts % 2);
    const dummyElements = products && Array.from({ length: isMobile ?mobileDummyElementsCount : dummyElementsCount }).map((_, index) => (
        <div key={`dummy-${index}`} style={{ flex: isMobile ? "1 1 45%" : "1 1 23%", opacity: 0 }}>
            <DummyCard data={{}} />
        </div>
    ));

    return (
        <Container maxWidth={1200}>
            <div
                style={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "wrap",
                }}
            >
                {products && products.map((data, index) => {

                    return <ProductCard data={data} />;
                })}
                {totalProducts % 4 !== 0 && dummyElements}
            </div>
        </Container>

    );
}

export default ProductList;